import _ from "lodash";
export default {
  package: (state, getters) => (id) => {
    return _.find(state.packages, ["id", id]);
  },
  packagesBySport: (state, getters) => (sport) => {
    return _.sortBy(
      _.filter(state.packages, ["sports_id", sport]),
      "id"
    ).reverse();
  },
  sports: (state, getters) => () => {
    return state.sports;
  },
  picks: (state, getters) => () => {
    return state.picks;
  },
  editUser: (state, getters) => () => {
    return state.editUser;
  },
  upcoming: (state) => () => {
    return _.get(state.odds[state.selectedSport], "upcoming.data") || [];
  },
  live: (state) => () => {
    return _.get(state.odds[state.selectedSport], "live.data") || [];
  },
  recent: (state) => () => {
    return _.get(state.odds[state.selectedSport], "recent.data") || [];
  },
  oddsForSport: (state) => () => {
    return state.odds[state.sport] || { upcoming: {}, live: {} };
  },
  // Cart getters
  cartItemCount: (state) => {
    return state.cart.reduce((total, item) => total + item.quantity, 0);
  },
  cartTotal: (state) => {
    return state.cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  }
};



// WEBPACK FOOTER //
// ./src/store/getters.js